import { render, staticRenderFns } from "./CustomerEditConfigurationsTab.vue?vue&type=template&id=75c70d02"
import script from "./CustomerEditConfigurationsTab.vue?vue&type=script&lang=ts"
export * from "./CustomerEditConfigurationsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports